export class MeasureStruct {
    public syncMeasurerHash: string = '';

    public thermometer: Thermometer = new Thermometer();

    public oximeter: Oximeter = new Oximeter();

    public bloodPressure: BloodPressure = new BloodPressure();

    public glucometer: Glucometer = new Glucometer();

    public isServerSync: boolean = false;

    public measureTime: Date | null = null;
}

export class Thermometer {
    public temperature: number | null = null;
}

export class Oximeter {
    public saturation: number | null = null;
    public heartRate: number | null = null;
}

export class BloodPressure {
    public bloodPressureSystole: number | null = null;
    public bloodPressureDiastole: number | null = null;
}

export class Glucometer {
    public glucose: number | null = null;
}